"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuShell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
const MenuShell_style_1 = require("./MenuShell.style");
function MenuShell({ animation = 'fade', children, visible = false, locked = false, }) {
    return ((0, jsx_runtime_1.jsx)(ui_common_components_1.Transition, { animation: animation, visible: visible, children: (0, jsx_runtime_1.jsx)(MenuShell_style_1.StyledWrapper, { locked: locked, children: (0, jsx_runtime_1.jsx)(MenuShell_style_1.StyledContent, { children: children }) }) }));
}
exports.MenuShell = MenuShell;
//# sourceMappingURL=MenuShell.js.map